import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: "/layout/home"
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@v/login/index.vue'),
    meta: {
      nokeepAlive: true,
    }
  },
  {
    path: '/forgotPassword',
    name: 'forgotPassword',
    component: () => import('@v/forgotPassword/index.vue'),
    meta: {
      nokeepAlive: true,
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@v/register/index.vue'),
    meta: {
      nokeepAlive: true,
    }
  },
  // {
  //   path: '/personalCenter',
  //   name: 'personalCenter',
  //   component: () => import('@v/personalCenter/index.vue'),
  //   meta: {
  //     nokeepAlive: true,
  //   }
  // },
  {
    path: '/layout',
    name: 'layout',
    redirect: "/layout/home",
    component: () => import('@v/layout/index.vue'),
    children: [
      {
        path: 'personalCenter',
        name: 'personalCenter',
        component: () => import('@v/personalCenter/index.vue'),
      }
    ],
  },
]

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
  routes
})

export default router
